import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewsComponent implements OnInit {

  cookieData: any
  isCrisis = false

  newsId = ""
  news: any = {}

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if(this.cookieData == null){
      this.cookieData = {}
    }
    this.isCrisis = this.cookieData.isCrisis

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.isCrisis = true
    }
    else {
      this.isCrisis = false
    }

    this.newsId = this.activatedRoute.snapshot.paramMap.get('id');
    await this.getNews()
  }

  async getNews(){
    let para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString()
    let newsList: any = await this.apiService.get("crmservice", "news", para)
    let newsFound: any = newsList.filter((n: any) => {
      return n.dpa_newandactivityid == this.newsId
    })

    if(newsFound != null && newsFound.length > 0){
      this.news = newsFound[0]
    }
    else{
      this.news = {}
    }
  }

  goToHome(){
    this.router.navigate(["mainmenu/index"])
  }

}



// WEBPACK FOOTER //
// ./src/app/news/news.component.ts